/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * UserOrgMappingService to save institution data to gps.
 * @author Satyaki Bose
 */

/* eslint-disable class-methods-use-this */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class UserOrgMappingService extends BaseService {
  constructor() {
    super(constants.USER_ORG_MAPPING_REQUESTED, 'userOrgMappingStatus');
  }

  handleEvent(eventName, eventData = {}) {
    const {
      orgId
    } = eventData;

    if (!orgId) {
      return Promise.reject(new Error('Missing orgId for user-org mapping'));
    }

    return this.getClient('marin').post(
      '/organizations/enroll', {
        orgId
      }
    );
  }

  handleResponse(response, eventData = {}) {
    Framework.getEventManager().publish(constants.USER_ORG_MAPPING_FETCHED, {
      ...response?.data,
      ...eventData
    });
  }

  handleError(error) {
    Framework.getEventManager().publish(constants.USER_ORG_MAPPING_FAILED, error);
    // eslint-disable-next-line no-console
    console.log(error, 'User org mapping service error');
  }
}
